<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <tree-table :data="tree"
                :columns="columns"
                :height="height"
                :loading="loading"
                stripe
                @on-toggle-expand="toggleExpand"
                ref="resTree">
                <template #type="{row}">
                    <div @contextmenu="contextMenu(row, $event)">
                        {{RESOURCE_TYPE.getName(row.type)}}
                    </div>
                </template>
            </tree-table>
            <smart-modal :title="formTitle"
                v-model="showResourceForm"
                :height="455"
                :width="800"
                @close-by-confirm="fetch">
                <resource-form v-if="showResourceForm"
                    :list="resourceList"
                    :id="resId"
                    :pid="resPid"
                    :type="resType"></resource-form>
            </smart-modal>
            <!-- 右键菜单 -->
            <ul v-show="showContextMenu"
                :style="{left: contextMenuLeft + 'px', top: contextMenuTop + 'px'}"
                class="contextmenu">
                <li v-for="(item, key) of contextMenuList"
                    :key="key"
                    @click="onMenuClick(item.id)">{{item.text}}</li>
            </ul>
        </div>
    </div>
</template>
<script>
import { mapCell } from '_c/grid/renderCell'
import { listToTree } from '_u/helper'
import { resList, resDelete, resBatchAdd } from '@/api/sys-res'
import Enum from '_u/enum'
import ResourceForm from './resourceForm'

const RESOURCE_TYPE = Enum.get('resourceType')

export default {
    components: {
        ResourceForm
    },
    data() {
        return {
            RESOURCE_TYPE,
            tree: [],
            loading: false,
            prodList: [],
            height: 'auto',
            resId: '',
            resType: 0,
            resPid: '',
            showResourceForm: false,
            foldMap: [], //{id: "", expand: true}
            resourceList: [],
            // 开发上下文辅助菜单
            contextMenuList: [
                { id: 'groupDef', text: '生成默认分组' },
                { id: 'actionEdit', text: '生成维护功能点' },
                { id: 'actionView', text: '生成查看功能点' },
                { id: 'refresh', text: '刷新数据' }
            ],
            showContextMenu: false,
            curRow: null,
            contextMenuTop: 0,
            contextMenuLeft: 0,
        }
    },
    computed: {
        columns() {
            return [{
                    title: '菜单名称',
                    key: 'title',
                    minWidth: 180
                },
                {
                    title: '菜单代码',
                    key: 'code',
                    width: 180
                },
                {
                    title: '图标',
                    key: 'icon',
                    align: 'center',
                    width: 80,
                    render: (h, { row }) => {
                        return <CommonIcon type={'_' + row.icon}></CommonIcon>
                    }
                },
                {
                    title: '类型',
                    key: 'type',
                    width: 80,
                    slot: 'type'
                },
                {
                    title: '地址',
                    key: 'uri',
                    width: 180,
                    tooltip: true
                },
                {
                    title: '操作',
                    render: this.action,
                    align: 'center',
                    width: 180
                }
            ]
        },
        formTitle() {
            var title = this.resId ? '修改' : '新增'
            title += RESOURCE_TYPE.displayNameOf(this.resType)
            return title
        }
    },
    methods: {
        toggleExpand(el) {
            let obj = this.foldMap.find(val => val.id === el.data.id)
            if (obj) {
                obj.expand = el._isExpand
            } else {
                this.foldMap.push({ id: el.data.id, expand: el._isExpand })
            }
        },

        fetch() {
            this.loading = true
            resList()
                .then(res => {
                    var list = res.data.list

                    list.sort((a, b) => a.sortNum - b.sortNum)
                    this.resourceList = list
                    this.setTreeData()
                })
                .finally(() => (this.loading = false))
        },

        setTreeData() {
            let list = JSON.parse(JSON.stringify(this.resourceList))
            this.foldMap.forEach(el => {
                let obj = list.find(val => val.id === el.id)
                if (obj) {
                    obj.expand = el.expand
                }
            })
            this.tree = listToTree(list, { id: 'id', pId: 'pid' })
        },

        action(h, { row }) {
            var addDropDown = null

            if (
                row.type == RESOURCE_TYPE.root ||
                row.type == RESOURCE_TYPE.directory
            ) {
                addDropDown = (
                    <Dropdown onOn-click={name => this.addRes(name, row)}>
                        <Button
                            type="default"
                            size="small"
                            style="margin-right: 5px"
                        >
                            新增
                        </Button>
                        <DropdownMenu
                            slot="list"
                            style={{
                                minWidth: '60px',
                                padding: 0,
                                textAlign: 'center'
                            }}
                        >
                            <DropdownItem name={RESOURCE_TYPE.directory}>
                                目录
                            </DropdownItem>
                            <DropdownItem name={RESOURCE_TYPE.menu}>
                                菜单
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                )
            }

            if (row.type == RESOURCE_TYPE.menu) {
                addDropDown = (
                    <Dropdown onOn-click={name => this.addRes(name, row)}>
                        <Button
                            type="default"
                            size="small"
                            style="margin-right: 5px"
                        >
                            新增
                        </Button>
                        <DropdownMenu
                            slot="list"
                            style={{
                                minWidth: '60px',
                                padding: 0,
                                textAlign: 'center'
                            }}
                        >
                            <DropdownItem name={RESOURCE_TYPE.menu}>
                                菜单
                            </DropdownItem>
                            <DropdownItem name={RESOURCE_TYPE.tab}>
                                页签
                            </DropdownItem>
                            <DropdownItem name={RESOURCE_TYPE.group}>
                                分组
                            </DropdownItem>
                            <DropdownItem name={RESOURCE_TYPE.action}>
                                功能
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                )
            }

            if (row.type == RESOURCE_TYPE.tab) {
                addDropDown = (
                    <Dropdown onOn-click={name => this.addRes(name, row)}>
                        <Button
                            type="default"
                            size="small"
                            style="margin-right: 5px"
                        >
                            新增
                        </Button>
                        <DropdownMenu
                            slot="list"
                            style={{
                                minWidth: '60px',
                                padding: 0,
                                textAlign: 'center'
                            }}
                        >
                            <DropdownItem name={RESOURCE_TYPE.tab}>
                                页签
                            </DropdownItem>
                            <DropdownItem name={RESOURCE_TYPE.group}>
                                分组
                            </DropdownItem>
                            <DropdownItem name={RESOURCE_TYPE.action}>
                                功能
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                )
            }

            if (row.type == RESOURCE_TYPE.group) {
                addDropDown = (
                    <Dropdown onOn-click={name => this.addRes(name, row)}>
                        <Button
                            type="default"
                            size="small"
                            style="margin-right: 5px"
                        >
                            新增
                        </Button>
                        <DropdownMenu
                            slot="list"
                            style={{
                                minWidth: '60px',
                                padding: 0,
                                textAlign: 'center'
                            }}
                        >
                            <DropdownItem name={RESOURCE_TYPE.group}>
                                分组
                            </DropdownItem>
                            <DropdownItem name={RESOURCE_TYPE.action}>
                                功能
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                )
            }

            // 无新增权限
            if (this.$can('add') == false) {
                addDropDown = ''
            }

            if (row.type == RESOURCE_TYPE.root) {
                return <div>{addDropDown}</div>
            } else {
                return (
                    <div>
                        {addDropDown}
                        {this.$can('update') ? (
                            <Button
                                type="default"
                                size="small"
                                style={{ marginRight: '5px' }}
                                onClick={() => this.updateRes(row)}
                            >
                                修改
                            </Button>
                        ) : (
                            ''
                        )}
                        {this.$can('delete') ? (
                            <PoptipButton
                                text="删除"
                                type="default"
                                title="您确定删除这条记录吗？"
                                ok={() => this.deleteRes(row)}
                            >
                                删除
                            </PoptipButton>
                        ) : (
                            ''
                        )}
                    </div>
                )
            }
        },

        addRes(type, res) {
            this.resId = ''
            this.resPid = res.id
            this.resType = type
            this.showResourceForm = true
        },

        updateRes(res) {
            this.resId = res.id
            this.resPid = res.pid
            this.resType = res.type
            this.showResourceForm = true
        },

        deleteRes(res) {
            resDelete(res.id).then(res => this.fetch())
        },

        contextMenu(row, e) {
            if (this.isDev == false) {
                return
            }

            e.preventDefault()

            var target = e.target
            var { left, top, height, width } = target.getBoundingClientRect()

            this.curRow = row
            this.showContextMenu = !this.showContextMenu
            this.contextMenuLeft = left
            this.contextMenuTop = top + height
        },

        onMenuClick(id) {
            return Promise.resolve()
                .then(() => {
                    this.showContextMenu = false

                    if (id == 'actionEdit') {
                        if (
                            this.curRow.type == RESOURCE_TYPE.menu ||
                            this.curRow.type == RESOURCE_TYPE.tab ||
                            this.curRow.type == RESOURCE_TYPE.group
                        ) {
                            return this.batchAddAction(this.curRow.id, [{
                                    title: '新增',
                                    uri: '/add',
                                    type: RESOURCE_TYPE.action,
                                    sortNum: 2
                                },
                                {
                                    title: '修改',
                                    uri: '/update',
                                    type: RESOURCE_TYPE.action,
                                    sortNum: 3
                                },
                                {
                                    title: '删除',
                                    uri: '/delete',
                                    type: RESOURCE_TYPE.action,
                                    sortNum: 4
                                }
                            ])
                        } else {
                            this.$Message.error(
                                '只能在菜单/页签/分组下添加功能点'
                            )
                        }
                    }

                    if (id == 'actionView') {
                        if (
                            this.curRow.type == RESOURCE_TYPE.menu ||
                            this.curRow.type == RESOURCE_TYPE.tab ||
                            this.curRow.type == RESOURCE_TYPE.group
                        ) {
                            return this.batchAddAction(this.curRow.id, [{
                                title: '查看',
                                uri: '/view',
                                type: RESOURCE_TYPE.action,
                                sortNum: 1
                            }])
                        } else {
                            this.$Message.error(
                                '只能在菜单/页签/分组下添加功能点'
                            )
                        }
                    }

                    if (id == 'groupDef') {
                        if (
                            this.curRow.type == RESOURCE_TYPE.menu ||
                            this.curRow.type == RESOURCE_TYPE.tab
                        ) {
                            return this.batchAddAction(this.curRow.id, [
                                // { title: '查看', uri: '', type: RESOURCE_TYPE.group, sortNum: 1 },
                                {
                                    title: '查看',
                                    uri: '/view',
                                    type: RESOURCE_TYPE.action,
                                    sortNum: 1
                                },
                                {
                                    title: '维护',
                                    uri: '',
                                    type: RESOURCE_TYPE.group,
                                    sortNum: 1
                                }
                            ])
                        } else {
                            this.$Message.error('只能在菜单/页签下添加分组')
                        }
                    }

                    if (id == 'refresh') {
                        this.fetch()
                    }
                })
                .then(res =>
                    res ? this.$Message.success('添加成功，刷新后可见') : ''
                )
        },

        // 批量资源添加函数
        batchAddAction(pid, list) {
            return resBatchAdd({
                pid,
                list: JSON.stringify(list)
            })
        }
    },

    mounted() {
        this.fetch()
        this.afterContainerResize((el, detector) => {
            this.height =
                detector.windowHeight -
                this.$refs.resTree.$el.getBoundingClientRect().top -
                40
        })
    }
}
</script>
<style lang="less"
    scoped>
.contextmenu {
    position: fixed;
    background-color: #fff;
    list-style: none;
    padding: 10px 0;
    border: 1px solid #ccc;

    li {
        padding: 0 10px;
        line-height: 24px;
        cursor: pointer;

        &:hover {
            background-color: #ccc;
        }
    }
}
</style>